export default {
  // 标题
  transactionOverview: "交易概况",
  assetDistribution: "资产分布",

  // 工具提示
  unitTooltip: "单位：右侧选中的币种",

  // 币种选择
  selectCurrency: "请选择币种",

  // 统计标签
  addressBalance: "地址余额",
  cumulativeInflowOutflow: "累计转入&转出数量",
  averageInflowOutflow: "平均转入&转出数量",
  inflowOutflowCount: "转入&转出笔数",
  inflowOutflowOpponents: "转入&转出对手数",

  // 空状态
  noData: "暂无数据",

  // 图表系列名称
  assetDistributionSeries: "资产分布",
};
